import { prop, arrayToObject } from '../../utilities';

function getSanitasProductDefaultInfo(product, goodName = 'main_good') {
  const unit = prop(product, `${goodName}.units`) || 'ks';
  const heliosUnit = prop(product, `${goodName}.helios_units`);
  const correctUnit = heliosUnit || unit;

  const customOrderNrs = prop(product, `${goodName}.custom_order_nr`, ['']);
  const orderNr = customOrderNrs
    ? customOrderNrs[customOrderNrs.length - 1]
    : '';

  const b2bDiscount = prop(product, `${goodName}.b2b_discount`, null);
  const assembling = prop(product, 'assembling');
  const storesInfo = prop(product, `${goodName}.stores_info`, null);
  const onStockCount = prop(product, `${goodName}.on_stock_count`, 0);
  const customerDiscount = prop(product, `${goodName}.customer_discount`);
  const price = prop(product, `${goodName}.final_price`);
  const oldPrice = prop(product, `${goodName}.oldprice`);
  const priceWithoutVat = prop(product, `${goodName}.final_price_without_vat`);
  const unpackingCost = prop(product, `${goodName}.sum_unpacking_cost`);
  const unpackingCostWithoutVat = prop(
    product,
    `${goodName}.sum_unpacking_cost_without_vat`,
  );
  const showB2C = prop(product, 'status_b2c') ? false : true;
  const showB2B = prop(product, 'status_b2b') ? false : true;
  const statusB2C = prop(product, 'status_b2c', 0);
  const statusB2B = prop(product, 'status_b2b', 0);
  const freeDelivery = prop(product, 'free_delivery', false);
  const specialDiscountPcn = prop(product, `${goodName}.special_discount_pcn`);
  const specialDiscount = prop(product, `${goodName}.special_discount`);
  const specialDiscountWithoutVat = prop(
    product,
    `${goodName}.special_discount_without_vat`,
  );
  const customerDiscountPcn = prop(
    product,
    `${goodName}.customer_discount_pcn`,
  );
  const productPackages = prop(product, 'productPackages', []);
  const customerPrices = prop(product, `${goodName}.customer_prices`);
  const photogallery = prop(product, 'photogallery');
  const picture = prop(product, 'picture');

  return {
    photogallery,
    freeDelivery,
    unit: correctUnit,
    onStock: onStockCount,
    price: price ? price.toFixed(2) : 0,
    priceWithoutVat: priceWithoutVat ? priceWithoutVat.toFixed(2) : 0,
    oldPrice: oldPrice ? oldPrice.toFixed(2) : 0,
    assembling,
    orderNr,
    priceForPiece: priceWithoutVat ? priceWithoutVat.toFixed(2) : 0,
    customerDiscount: customerDiscount ? customerDiscount.toFixed(2) : 0,
    b2bDiscount,
    unpackingCost,
    unpackingCostWithoutVat,
    storesInfo,
    showB2C,
    showB2B,
    statusB2C,
    statusB2B,
    customerDiscountPcn,
    specialDiscountPcn,
    specialDiscount,
    specialDiscountWithoutVat,
    customerPrices,
    productPackages,
    picture,
    image: picture
      ? `https://www.sanitaske.sk/api/v1/image?query=${picture}&width=320&height=320&webp=0`
      : '/images/sanitaske/placeholder.svg',
  };
}

const getElasticCategorySanitasProductInfo = (product, isB2B) => {
  const unit = prop(product, 'helios_units')
    ? prop(product, 'helios_units')
    : 'ks';
  const isMks = unit === 'Mks';

  const storesInfo = prop(product, `stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;
  const correctZemplinCount = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;
  const onStockCount = correctZemplinCount
    ? correctZemplinCount
    : prop(product, `main_good_stock_count`, 0);
  const correctCount = isMks ? onStockCount / 1000 : onStockCount;

  const price = prop(product, `product_detail.main_good.final_price`);
  const priceWithoutVat = prop(
    product,
    `product_detail.main_good.final_price_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(6)
      : price.toFixed(6)
    : '';

  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(6)
      : priceWithoutVat.toFixed(6)
    : '';

  const productPackages = prop(product, `product_packages`);
  const goods = prop(product, `product_detail.goods`, []);
  const minQuantity = goods ? prop(goods[0], `order_quantity_min`, null) : null;
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const unpackingCost = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost`,
  );
  const unpackingCostWithoutVat = prop(
    product,
    `product_detail.main_good.sum_unpacking_cost_without_vat`,
  );

  const customOrderNrs = prop(
    product,
    'product_detail.main_good.custom_order_nr',
  );
  const customOrderNr =
    customOrderNrs && customOrderNrs[0] ? customOrderNrs : null;

  const statusB2C = prop(product, 'status_b2c', 0);
  const statusB2B = prop(product, 'status_b2b', 0);
  const showB2C = prop(product, 'status_b2c') ? false : true;
  const showB2B = prop(product, 'status_b2b') ? false : true;
  const statusShowPrice = isB2B ? statusB2B !== 3 : statusB2C !== 3;
  const statusShowAddToCart = isB2B ? statusB2B === 0 : statusB2C === 0;

  const specialDiscountPcn = prop(
    product,
    `product_detail.main_good.special_discount_pcn`,
  );
  const specialDiscount = prop(
    product,
    `product_detail.main_good.special_discount`,
  );
  const specialDiscountWithoutVat = prop(
    product,
    `product_detail.main_good.special_discount_without_vat`,
  );
  const currency = prop(product, 'product_detail.main_good.currency.name', '')
    ? '€'
    : '€';
  const correctShownSpecialDiscount =
    specialDiscountPcn && specialDiscountPcn !== 0
      ? specialDiscountPcn
      : isB2B
      ? specialDiscountWithoutVat
      : specialDiscount;
  const correctShownSpecialDiscountText =
    correctShownSpecialDiscount && correctShownSpecialDiscount !== 0
      ? specialDiscountPcn && specialDiscountPcn
        ? `-${correctShownSpecialDiscount}%`
        : `${(isMks
            ? correctShownSpecialDiscount * 1000
            : correctShownSpecialDiscount
          ).toFixed(2)}${currency}`
      : '';
  const freeDelivery = prop(product, `product_detail.free_delivery`);
  const priceForUnpacking = prop(
    product,
    'product_detail.main_good.price_for_unpacking',
  );
  const customerPrices = prop(
    product,
    `product_detail.main_good.customer_prices`,
  );

  return {
    priceForUnpacking,
    freeDelivery,
    onStock: correctCount,
    storesInfo,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    unit,
    productPackages: correctPackageNumber,
    unpackingCost,
    unpackingCostWithoutVat,
    customOrderNr,
    showB2C,
    showB2B,
    statusShowPrice,
    statusShowAddToCart,
    specialDiscount: correctShownSpecialDiscountText,
    customerPrices,
    correctShownSpecialDiscount,
  };
};

function getSanitasCartProductInfo(product) {
  const unit = prop(product, 'good.units') || 'ks';
  const heliosUnit = prop(product, 'good.helios_units');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';

  const productPackages = prop(product, 'product.productPackages', []);
  const minQuantity = prop(product, `good.order_quantity_min`);
  const correctPackageNumber = minQuantity
    ? isMks
      ? minQuantity / 1000
      : minQuantity
    : getCorrectPackageNumber(productPackages, isMks);

  const count = prop(product, 'count');
  const correctCount = isMks ? count / 1000 : count;

  const unitPrice = prop(product, `good.unitprice`);

  const price = prop(product, `good.final_price`);
  const priceWithoutVat = prop(product, `good.final_price_without_vat`);
  const sumPrice = prop(product, `sum_price`);
  const sumPriceWithoutVat = prop(product, `sum_price_without_vat`);
  const finalPricePerUnitWithVat = prop(
    product,
    `final_price_per_unit_with_vat`,
  );
  const finalPricePerUnitWithoutVat = prop(
    product,
    `final_price_per_unit_without_vat`,
  );

  const correctPrice = price
    ? isMks
      ? (1000 * price).toFixed(6)
      : price.toFixed(6)
    : '';
  const correctPriceWithoutVat = priceWithoutVat
    ? isMks
      ? (1000 * priceWithoutVat).toFixed(6)
      : priceWithoutVat.toFixed(6)
    : '';
  const correctFinalPricePerUnitWithVat = finalPricePerUnitWithVat
    ? finalPricePerUnitWithVat.toFixed(6)
    : '';
  const correctFinalPricePerUnitWithoutVat = finalPricePerUnitWithoutVat
    ? finalPricePerUnitWithoutVat.toFixed(6)
    : '';

  const storesInfo = prop(product, `good.stores_info`, null);
  const storesInfoObj = storesInfo
    ? arrayToObject(storesInfo, 'store_id')
    : null;
  const correctZemplinCount = storesInfoObj
    ? prop(storesInfoObj, 'internal.quantity')
    : null;
  const onStockCount = correctZemplinCount
    ? correctZemplinCount
    : prop(product, `good.on_stock_count`, 0);
  const b2BDiscount = prop(product, `good.b2b_discount`);
  const priceForUnpacking = prop(product, `unpacking_cost`);

  return {
    priceForUnpacking,
    count: correctCount,
    unit: correctUnit,
    productPackages: correctPackageNumber,
    price: correctPrice,
    priceWithoutVat: correctPriceWithoutVat,
    priceForPiece: price,
    priceForPieceWithoutVat: priceWithoutVat,
    sumPrice: sumPrice ? sumPrice.toFixed(2) : '',
    sumPriceWithoutVat: sumPriceWithoutVat ? sumPriceWithoutVat.toFixed(2) : '',
    onStock: onStockCount,
    storesInfo,
    finalPricePerUnitWithVat: correctFinalPricePerUnitWithVat,
    finalPricePerUnitWithoutVat: correctFinalPricePerUnitWithoutVat,
    b2BDiscount,
    unitPrice,
  };
}

function getSanitasCartSummaryInfo(cart) {
  const vatGroups = prop(cart, 'vat_groups', null);
  if (!vatGroups) {
    return {
      vatGroups: null,
    };
  }
  const vatGroup0Total = prop(vatGroups['0'], 'price_without_vat')
    ? prop(vatGroups['0'], 'price_without_vat').toFixed(2)
    : null;
  const vatGroup0TotalWithDph = prop(vatGroups['0'], 'price')
    ? prop(vatGroups['0'], 'price').toFixed(2)
    : null;
  const vatGroup20Total = prop(vatGroups['20'], 'price_without_vat')
    ? prop(vatGroups['20'], 'price_without_vat').toFixed(2)
    : null;
  const vatGroup20TotalWithDph = prop(vatGroups['20'], 'price')
    ? prop(vatGroups['20'], 'price').toFixed(2)
    : null;
  const vatGroup20TotalDph = vatGroup20TotalWithDph - vatGroup20Total;

  return {
    vatGroup0Total,
    vatGroup0TotalWithDph,
    vatGroup20Total,
    vatGroup20TotalWithDph,
    vatGroup20TotalDph: vatGroup20TotalDph
      ? vatGroup20TotalDph.toFixed(2)
      : null,
  };
}

function getZemplinTrueCount(isMks: boolean, count: number) {
  return isMks ? Math.round(count * 1000) : count;
}

function getZemplinTrueCountFromNormalCount(isMks: boolean, count: number) {
  return isMks ? count / 1000 : count;
}

function getCorrectPackageNumber(packages, isMks: boolean) {
  if (!packages || packages.length === 0) {
    return 0;
  }

  const packageNumbers = packages.map(p => p.type);
  const min = Math.min(...packageNumbers);

  return isMks ? min / 1000 : min;
}

function isOrderingLessThanMinimum(product) {
  const {
    count,
    productPackages,
    priceForUnpacking,
  } = getSanitasCartProductInfo(product);
  if (
    count < productPackages &&
    productPackages >= 0.026 &&
    priceForUnpacking &&
    priceForUnpacking * +count < 4
  ) {
    return true;
  }

  return false;
}

function getSanitasRequestDetailItemInfo(item) {
  const unit = prop(item, 'good_details_json.units');
  const heliosUnit = prop(item, 'good_details_json.heliosUnits');
  const correctUnit = heliosUnit || unit;
  const isMks = correctUnit === 'Mks';
  const quantity = prop(item, 'quantity');

  const correctCount = isMks ? quantity / 1000 : quantity;

  return {
    count: correctCount,
    unit: correctUnit,
  };
}

function shouldShowPriceIfNotOnStock(categoryIds: string[]) {
  return !categoryIds.includes('SPOJ_MATERIAL');
}

function isCategory(categoryIds: string[], wantedCategory: string) {
  return categoryIds.includes(wantedCategory);
}

function findCategoryIdFromArray(categoryIds: string[]) {
  if (categoryIds.includes('CENTRUM_VYKUROV')) {
    return 'CENTRUM_VYKUROV';
  }

  if (categoryIds.includes('PRE_DREVAROV')) {
    return 'PRE_DREVAROV';
  }

  if (categoryIds.includes('OSTATNE')) {
    return 'OSTATNE';
  }

  return 'SPOJ_MATERIAL';
}

const getDownloadFileInfo = download => {
  const id = prop(download, 'document_id', '');
  const path = prop(download, 'document_path');
  const name = prop(download, 'document_name', '');
  const fullPath = `https://www.sanitaske.sk/api/v1/file?query=${path}`;
  const desc = prop(download, 'document_description', '');

  return { id, name, path: fullPath, desc };
};

export {
  getSanitasProductDefaultInfo,
  getElasticCategorySanitasProductInfo,
  getSanitasCartProductInfo,
  getZemplinTrueCount,
  getCorrectPackageNumber,
  getSanitasRequestDetailItemInfo,
  isOrderingLessThanMinimum,
  getZemplinTrueCountFromNormalCount,
  getSanitasCartSummaryInfo,
  shouldShowPriceIfNotOnStock,
  isCategory,
  findCategoryIdFromArray,
  getDownloadFileInfo,
};
